<template>
  <div>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="createFiles">Create Points File</v-btn>
        <v-btn color="primary" @click="sendFiles">Send File to Qantas</v-btn>
        <v-btn color="primary" @click="PollQBRServer">Poll QBR Server</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <points-table
          :customers="sent"
          :headers="headers"
          @refresh="getSentRecords"
          >Transmitted Records</points-table
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import pointsTable from "@/components/qantas/points-table";
export default {
  name: "PointsManagementReportsent",
  components: {
    pointsTable
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        descending: false
      },
      sent: [],
      headers: [
        {
          text: "Cust #",
          value: "custNo",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "CSN",
          value: "csn",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Date Paid",
          value: "datePaid",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Points Paid",
          value: "pointsPaid",
          align: "left",
          sortable: true
        },
        {
          text: "Return Result",
          value: "returnResult",
          align: "left",
          sortable: true
        },
        {
          text: "Reason",
          value: "rejectionReason",
          align: "left",
          sortable: true
        },
        {
          text: "Fileset No.",
          value: "fileSetNumber",
          align: "left",
          sortable: true
        },
        {
          text: "Sequence No",
          value: "sequenceNumber",
          align: "left",
          sortable: true
        }
      ]
    };
  },
  mounted() {
    let vm = this;
    vm.getSentRecords();
  },
  methods: {
    ...mapActions("qantas", [
      "GetSentTransmissions",
      "sendFiles",
      "PollQBRServer",
      "createFiles"
    ]),
    getSentRecords() {
      let vm = this;
      vm.GetSentTransmissions().then(data => {
        vm.sent = data;
      });
    }
  }
};
</script>
